import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import moment from 'moment';

import CustomPagination from '../../CustomPagination/CustomPagination';
import Link from '../../Link/Link';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';
import CurrencyConverter from '../../CurrencyConverter';
import { Modal } from 'react-bootstrap';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../../helpers/showToaster';
import messages from '../../../locale/messages';

import s from './InquiryManagement.css';
class InquiryManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false,
            showAdvanceModal: false,
            showEditAdvanceModal: false,
            selectedReservation: null,
            advanceAmount: '',
            editAdvanceAmount: '',
            paymentMethodId: 3,
            sortBy: null,
            sortOrder: 'DESC',
            paymentStatusFilter: '',
            reservationStatusFilter: ''
        }
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    handleSearchChange = (e) => {
        const { getAllInquiryQuery: { refetch }, changeStateValues } = this.props;
        const { sortBy, sortOrder, paymentStatusFilter, reservationStatusFilter } = this.state;
        let variables = {
            currentPage: 1,
            searchList: e.target.value,
            sortBy,
            sortOrder,
            paymentStatusFilter,
            reservationStatusFilter
        };
        changeStateValues({
            currentPage: 1,
            searchList: e.target.value,
        });
        refetch(variables);
    }

    paginationData = (currentPage) => {
        const { getAllInquiryQuery: { refetch }, changeStateValues, searchList } = this.props;
        const { sortBy, sortOrder, paymentStatusFilter, reservationStatusFilter } = this.state;
        let variables = { currentPage, searchList, sortBy, sortOrder, paymentStatusFilter, reservationStatusFilter };
        changeStateValues({ currentPage });
        refetch(variables);
    }

    handleSort = (columnName) => {
        const { getAllInquiryQuery: { refetch }, searchList } = this.props;
        const { sortBy, sortOrder, paymentStatusFilter, reservationStatusFilter } = this.state;

        let newSortOrder = 'DESC';
        if (sortBy === columnName && sortOrder === 'DESC') {
            newSortOrder = 'ASC';
        }

        this.setState({ sortBy: columnName, sortOrder: newSortOrder });

        let variables = {
            currentPage: 1,
            searchList,
            sortBy: columnName,
            sortOrder: newSortOrder,
            paymentStatusFilter,
            reservationStatusFilter
        };
        refetch(variables);
    }

    takeAction = async (threadId) => {
        const { refetch } = this.props;
        let query = `query checkThreadData($threadId:Int){
            checkThreadData(threadId:$threadId){
                status
            }
        }`;

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables: { threadId },
            }),
            credentials: 'include',
        });

        const { data } = await resp.json();
        if (data?.checkThreadData?.status == '200') {
            return true
        } else {
            showToaster({ messageId: 'alreadyApprove', toasterType: 'error' })
            let variables = {
                searchKey: '',
                currentPage: 1
            };
            await refetch(variables)
            return false
        }
    }

    openAdvanceModal = (reservation) => {
        this.setState({
            showAdvanceModal: true,
            selectedReservation: reservation,
            advanceAmount: reservation.advanceDeposit || '',
            paymentMethodId: reservation.paymentMethodId || 3
        });
    }

    getPaymentMethodLabel = (paymentMethod) => {
        if (!paymentMethod) {
            return 'N/A';
        }

        if (paymentMethod?.id === 3 || paymentMethod?.paymentName === 'Konnect') {
            return 'Click-to-Pay';
        }

        return paymentMethod?.paymentName || 'N/A';
    }

    closeAdvanceModal = () => {
        this.setState({
            showAdvanceModal: false,
            selectedReservation: null,
            advanceAmount: '',
            paymentMethodId: 3
        });
    }

    openEditAdvanceModal = (reservation) => {
        this.setState({
            showEditAdvanceModal: true,
            selectedReservation: reservation,
            editAdvanceAmount: reservation.advanceDeposit || ''
        });
    }

    closeEditAdvanceModal = () => {
        this.setState({
            showEditAdvanceModal: false,
            selectedReservation: null,
            editAdvanceAmount: ''
        });
    }

    handleEditAdvanceChange = (e) => {
        const value = e.target.value;
        if (value === '' || parseFloat(value) >= 0) {
            this.setState({ editAdvanceAmount: value });
        }
    }

    handleEditAdvanceSubmit = async () => {
        const { editAdvanceAmount, selectedReservation } = this.state;
        const { getAllInquiryQuery: { refetch } } = this.props;

        if (!editAdvanceAmount || parseFloat(editAdvanceAmount) < 0) {
            showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'Please enter a valid advance amount' });
            return;
        }

        const mutation = `mutation editReservationAdvance($reservationId: Int!, $advanceDeposit: Float!) {
            editReservationAdvance(reservationId: $reservationId, advanceDeposit: $advanceDeposit) {
                status
            }
        }`;

        try {
            const resp = await fetch('/graphql', {
                method: 'post',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: mutation,
                    variables: {
                        reservationId: selectedReservation.id,
                        advanceDeposit: parseFloat(editAdvanceAmount)
                    },
                }),
                credentials: 'include',
            });

            const { data } = await resp.json();

            if (data?.editReservationAdvance?.status === 'success') {
                showToaster({ messageId: 'success', toasterType: 'success', requestContent: 'Advance amount updated successfully' });
                this.closeEditAdvanceModal();
                refetch();
            } else {
                showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'Failed to update advance amount' });
            }
        } catch (error) {
            showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'An error occurred' });
        }
    }

    handleAdvanceChange = (e) => {
        const value = e.target.value;
        // Only allow positive numbers
        if (value === '' || parseFloat(value) >= 0) {
            this.setState({ advanceAmount: value });
        }
    }

    handlePaymentMethodChange = (e) => {
        this.setState({ paymentMethodId: parseInt(e.target.value) });
    }

    handlePaymentStatusChange = (e) => {
        const { getAllInquiryQuery: { refetch }, searchList } = this.props;
        const { sortBy, sortOrder, reservationStatusFilter } = this.state;
        const paymentStatusFilter = e.target.value;

        this.setState({ paymentStatusFilter });

        let variables = {
            currentPage: 1,
            searchList,
            sortBy,
            sortOrder,
            paymentStatusFilter,
            reservationStatusFilter
        };
        refetch(variables);
    }

    handleReservationStatusChange = (e) => {
        const { getAllInquiryQuery: { refetch }, searchList } = this.props;
        const { sortBy, sortOrder, paymentStatusFilter } = this.state;
        const reservationStatusFilter = e.target.value;

        this.setState({ reservationStatusFilter });

        let variables = {
            currentPage: 1,
            searchList,
            sortBy,
            sortOrder,
            paymentStatusFilter,
            reservationStatusFilter
        };
        refetch(variables);
    }

    handleAdvanceSubmit = async () => {
        const { advanceAmount, selectedReservation, paymentMethodId } = this.state;
        const { getAllInquiryQuery: { refetch } } = this.props;

        if (!advanceAmount || parseFloat(advanceAmount) < 0) {
            showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'Please enter a valid advance amount' });
            return;
        }

        if (!paymentMethodId) {
            showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'Please select a payment method' });
            return;
        }

        const mutation = `mutation updateReservationAdvance($reservationId: Int!, $advanceDeposit: Float!, $paymentMethodId: Int!) {
            updateReservationAdvance(reservationId: $reservationId, advanceDeposit: $advanceDeposit, paymentMethodId: $paymentMethodId) {
                status
            }
        }`;

        try {
            const resp = await fetch('/graphql', {
                method: 'post',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: mutation,
                    variables: {
                        reservationId: selectedReservation.id,
                        advanceDeposit: parseFloat(advanceAmount),
                        paymentMethodId: parseInt(paymentMethodId)
                    },
                }),
                credentials: 'include',
            });

            const { data } = await resp.json();

            if (data?.updateReservationAdvance?.status === 'success') {
                showToaster({ messageId: 'success', toasterType: 'success', requestContent: 'Payment marked as completed successfully' });
                this.closeAdvanceModal();
                refetch();
            } else {
                showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'Failed to update payment' });
            }
        } catch (error) {
            showToaster({ messageId: 'error', toasterType: 'error', requestContent: 'An error occurred' });
        }
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        const { sortBy, sortOrder } = this.state;

        const getSortIcon = (columnName) => {
            if (sortBy !== columnName) {
                return '  ↕️';
            }
            return sortOrder === 'ASC' ? ' 🔼' : ' 🔽';
        };

        return [
            { data: formatMessage(messages.id) },
            { data: 'Guest Name' },
            { data: 'Guest Phone' },
            { data: 'Host Name' },
            { data: 'Host Phone' },
            { data: formatMessage(messages.bookingStatus) },
            { data: 'Payment Status' },
            { data: 'Payment Method' },
            { data: formatMessage(messages.adminListTitle) },
            { data: 'Total Amount' },
            { data: formatMessage(messages.checkInAndCheckOut) },
            { data: formatMessage(messages.details) },
            {
                data: (
                    <span
                        onClick={() => this.handleSort('createdAt')}
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Created At{getSortIcon('createdAt')}
                    </span>
                )
            },
            { data: 'View Messages' },
            { data: formatMessage(messages.bookingAction) },
        ]
    }


    tbody = (props) => {
        const { getAllInquiryQuery } = props;
        const { formatMessage } = props.intl;

        let userType = 'host';
        return getAllInquiryQuery?.getAllInquiryAdmin?.reservationData?.map((value, key) => {
            let checkIn = moment(value.checkIn).format('DD/MM/YYYY')
            let checkOut = moment(value.checkOut).format('DD/MM/YYYY')
            let createdAt = value.createdAt ? moment(parseInt(value.createdAt)).format('DD/MM/YYYY HH:mm') : 'N/A'
            let guestName = value?.guestProfile?.firstName && value?.guestProfile?.lastName
                ? `${value.guestProfile.firstName} ${value.guestProfile.lastName}`
                : value?.guestProfile?.displayName || 'N/A';
            let hostName = value?.hostProfile?.firstName && value?.hostProfile?.lastName
                ? `${value.hostProfile.firstName} ${value.hostProfile.lastName}`
                : value?.hostProfile?.displayName || 'N/A';

            return {
                id: key,
                data: [
                    { data: value?.id },
                    { data: guestName },
                    { data: value?.guestProfile?.phoneNumber || 'N/A' },
                    { data: hostName },
                    { data: value?.hostProfile?.phoneNumber || 'N/A' },
                    {
                        data: value?.reservationState ?
                            <span className={cx(s.statusPill, s[value.reservationState])}>
                                {value.reservationState}
                            </span> :
                            <span>N/A</span>
                    },
                    {
                        data: value?.paymentState ?
                            <span className={cx(s.statusPill, s[value.paymentState])}>
                                {value.paymentState}
                            </span> :
                            <span>N/A</span>
                    },
                    {
                        data: this.getPaymentMethodLabel(value?.paymentMethod)
                    },
                    {
                        data: value?.listData?.title ? <a href={"/rooms/" + value?.listId} target='_blank'>
                            {value?.listData?.title}
                        </a> :
                            formatMessage(messages.dataMissing)
                    },
                    { data: <CurrencyConverter
                                    amount={value?.total }
                                    from={value?.currency}
                                  /> },
                    { data: `${checkIn} - ${checkOut}` },
                    {
                        data: <Link to={"/siteadmin/viewreservation/" + value?.id + '/reservation'} >
                        <FormattedMessage {...messages?.viewLabel} />
                    </Link>
                    },
                    { data: createdAt },
                    {
                        data: value?.threadId ?
                            (
                                <a
                                    // onClick={() => this.takeAction(value.threadId)}
                                    target="_blank" href={"/message/" + value?.threadId + "/" + userType}
                                    className={cx(s.previewLink)}>
                                    View
                                </a>
                            ) : (<span>-</span>)
                    },
                   {
                        data: value?.reservationState === 'approved' ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                {value?.paymentState === 'pending' && value?.datesAvailable !== false && (
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.openAdvanceModal(value);
                                        }}
                                        className={cx(s.previewLink)}
                                        style={{ cursor: 'pointer' }}>
                                        Mark as Paid
                                    </a>
                                )}
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.openEditAdvanceModal(value);
                                    }}
                                    className={cx(s.previewLink)}
                                    style={{ cursor: 'pointer' }}>
                                    Edit Advance
                                </a>
                            </div>
                        ) : <span>-</span>
                    },
                ]
            }
        });
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { getAllInquiryQuery, getAllInquiryQuery: { loading }, currentPage, searchList, toCurrency } = this.props;
        const { showAdvanceModal, showEditAdvanceModal, selectedReservation, advanceAmount, editAdvanceAmount, paymentMethodId, paymentStatusFilter, reservationStatusFilter } = this.state;

        const customFilters = [
            {
                value: paymentStatusFilter,
                onChange: this.handlePaymentStatusChange,
                options: [
                    { value: '', label: 'All Payment Status' },
                    { value: 'pending', label: 'Pending' },
                    { value: 'completed', label: 'Completed' }
                ]
            },
            {
                value: reservationStatusFilter,
                onChange: this.handleReservationStatusChange,
                options: [
                    { value: '', label: 'All Reservation Status' },
                    { value: 'pending', label: 'Pending' },
                    { value: 'approved', label: 'Approved' },
                    { value: 'declined', label: 'Declined' },
                    { value: 'expired', label: 'Expired' },
                    { value: 'completed', label: 'Completed' },
                    { value: 'cancelled', label: 'Cancelled' }
                ]
            }
        ];

        return (
            <div>
                {loading && <div><Loader type={"text"} /></div>}
                {!loading && <div>
                    <CommonTable
                        title={formatMessage(messages.manageInquiry)}
                        thead={this.thead}
                        tbody={() => this.tbody(this.props)}
                        isSearch
                        handleSearch={(e) => this.handleSearchChange(e)}
                        exportURL={getAllInquiryQuery?.getAllInquiryAdmin?.reservationData?.length > 0 ? `/export-admin-data?type=inquiry&keyword=${searchList}&toCurrency=${toCurrency}` : null}
                        customFilters={customFilters}
                    />
                    {
                        getAllInquiryQuery?.getAllInquiryAdmin?.reservationData?.length > 0
                        && <div>
                            <CustomPagination
                                total={getAllInquiryQuery.getAllInquiryAdmin.count}
                                currentPage={currentPage}
                                defaultCurrent={1}
                                defaultPageSize={10}
                                change={this.paginationData}
                                paginationLabel={formatMessage(messages.panelInquiry)}
                                isScroll
                            />
                        </div>
                    }
                </div>}

                <Modal show={showAdvanceModal} onHide={this.closeAdvanceModal} dialogClassName={cx('adminModal')} >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Advance Payment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={s.modalRoot}>
                            <div className={s.modalContainer}>
                                <div className={s.formGroup}>
                                    <label htmlFor="advanceAmount">Advance Amount</label>
                                    <input
                                        id="advanceAmount"
                                        type="number"
                                        className={s.formControl}
                                        value={advanceAmount}
                                        onChange={this.handleAdvanceChange}
                                        placeholder="Enter advance amount"
                                        step="0.01"
                                        min="0"
                                    />
                                </div>
                                <div className={s.formGroup}>
                                    <label htmlFor="paymentMethod">Payment Method</label>
                                    <select
                                        id="paymentMethod"
                                        className={s.formControl}
                                        value={paymentMethodId}
                                        onChange={this.handlePaymentMethodChange}
                                    >
                                        <option value={3}>Click-to-Pay</option>
                                        <option value={4}>Virement</option>
                                        <option value={5}>Especes</option>
                                    </select>
                                </div>
                                {selectedReservation && (
                                    <div className={s.reservationInfo}>
                                        <p><strong>Reservation ID:</strong> {selectedReservation.id}</p>
                                        <p><strong>Total: </strong>
                                        <CurrencyConverter
                                    amount={selectedReservation.total }
                                    from={selectedReservation.currency}
                                  />
                                  </p>
                                    </div>
                                )}
                                <div className={s.buttonGroup}>
                                    <button
                                        className={cx(s.button, s.btnPrimary)}
                                        onClick={this.handleAdvanceSubmit}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        className={cx(s.button, s.btnSecondary)}
                                        onClick={this.closeAdvanceModal}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showEditAdvanceModal} onHide={this.closeEditAdvanceModal} dialogClassName={cx('adminModal')} >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Advance Amount</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={s.modalRoot}>
                            <div className={s.modalContainer}>
                                <div className={s.formGroup}>
                                    <label htmlFor="editAdvanceAmount">Advance Amount</label>
                                    <input
                                        id="editAdvanceAmount"
                                        type="number"
                                        className={s.formControl}
                                        value={editAdvanceAmount}
                                        onChange={this.handleEditAdvanceChange}
                                        placeholder="Enter advance amount"
                                        step="0.01"
                                        min="0"
                                    />
                                </div>
                                {selectedReservation && (
                                    <div className={s.reservationInfo}>
                                        <p><strong>Reservation ID:</strong> {selectedReservation.id}</p>
                                        <p><strong>Total: </strong>
                                            <CurrencyConverter
                                                amount={selectedReservation.total}
                                                from={selectedReservation.currency}
                                            />
                                        </p>
                                    </div>
                                )}
                                <div className={s.buttonGroup}>
                                    <button
                                        className={cx(s.button, s.btnPrimary)}
                                        onClick={this.handleEditAdvanceSubmit}
                                    >
                                        Save
                                    </button>
                                    <button
                                        className={cx(s.button, s.btnSecondary)}
                                        onClick={this.closeEditAdvanceModal}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        )
    }
};

const mapState = (state) => ({
    toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
    demoRestrictionEncode
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(InquiryManagement)));
